
<div *ngIf="imageVisible" style="border: 1px dotted #ddd;
border-radius: 0px;padding: 15px 10px;" fxLayout="row"
  fxLayoutAlign="space-between center" fxLayoutGap="10px">
  <div fxLayout="column">    

  <div fxLayout="row" fxLayoutGap="10px">

    <span fxLayoutAlign="start center">
        {{value}}
        <button [attr.guide]="'pdf-btn-1' + '__' + sanitizedUrl" (click)="download()"
        color="warn" mat-icon-button type="button" >
        <mat-icon>download

            </mat-icon>

        </button>

    </span>

    <ng-container fxLayoutAlign="end center">
        <button [attr.guide]="'pdf-btn-2' + '__' + sanitizedUrl" (click)="logo()" mat-raised-button>Upload</button>

        <button [attr.guide]="'pdf-btn-3' + '__' + sanitizedUrl" *ngIf="value!=''" (click)="deleteImage(0)"
         mat-raised-button>delete</button>
    </ng-container>

  </div>
</div>
</div>

<div *ngIf="!imageVisible&&!imageDelete" style="border: 1px dotted #ddd;border-radius: 0px;padding: 15px 10px;" fxLayout="row"
  fxLayoutAlign="space-between center" fxLayoutGap="10px">
  <calsoft-common-file-upload-pdf (fileUploadResult)=getResult($event) 
  [type]="'home'">
  </calsoft-common-file-upload-pdf>
  <button [attr.guide]="'pdf-btn-4' + '__' + sanitizedUrl" (click)="cancelUpload()" mat-raised-button>Cancel</button>
</div>

